import { useFeatureEnabledForConfig } from 'api/configurations';
import React, { PropsWithChildren } from 'react';
import { S4Feature } from 'types/api';

interface IEnabledFeatureCheckProps extends PropsWithChildren {
	feature: S4Feature;
}

/** Renders its children when the feature applies to this suite session's connection. */
const EnabledFeatureCheck: React.FC<IEnabledFeatureCheckProps> = ({
	feature,
	children = null
}) => {
	const { enabled } = useFeatureEnabledForConfig(feature);

	return enabled ? children : null;
};

export default EnabledFeatureCheck;
